var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { Tab } from 'semantic-ui-react';
import to from 'await-to-js';
import Axios from 'axios';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import DatabaseInformation from './DatabaseInformation';
import Code from './Code';
import SandboxItemActions from './SandboxItemActions';
import Backups from './Backups';
import AuraCloud from './AuraCloud';
var getCodeSnippetUrl = function (usecase, language) {
    switch (language) {
        case 'javascript':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/javascript/example.js");
        case 'java':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/java/Example.java");
        case 'python':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/python/example.py");
        case 'graphql':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/graphql/example.js");
        case 'graphqlschema':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/graphql/schema.graphql");
        case 'go':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/go/example.go");
        case 'csharp':
            return "https://raw.githubusercontent.com/neo4j-graph-examples/".concat(usecase, "/main/code/csharp/Example.cs");
        default:
            break;
    }
    return null;
};
var getCodePanel = function (data, codes) { return ({
    menuItem: 'Connect via drivers',
    render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
        React.createElement("p", { className: "font-bold mb1" }, "Use the code below to connect your app to this database instance."),
        React.createElement(Code, { data: data, codes: codes }))); },
}); };
var SandboxItemExpand = /** @class */ (function (_super) {
    __extends(SandboxItemExpand, _super);
    function SandboxItemExpand(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            js: null,
            php: null,
            java: null,
            py: null,
            graphql: null,
            graphqlschema: null,
            csharp: null,
            go: null,
            finalPanes: [],
        };
        _this.handleCopyToClipboard = _this.handleCopyToClipboard.bind(_this);
        _this.handleTabChange = _this.handleTabChange.bind(_this);
        var data = _this.props.data;
        var _a = _this.state, js = _a.js, java = _a.java, py = _a.py, graphql = _a.graphql, graphqlschema = _a.graphqlschema, go = _a.go, csharp = _a.csharp;
        _this.availablePanes = [
            {
                menuItem: 'Actions',
                render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
                    React.createElement(SandboxItemActions, { data: data }))); },
            },
            {
                menuItem: 'Connection details',
                render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
                    React.createElement(DatabaseInformation, { data: data }))); },
            },
            {
                menuItem: 'Backups',
                render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
                    React.createElement("p", { className: "font-bold mb1" }, "Here you can request a backup task for your database. After the task finishes you will be able to generate a download-link that will be valid for 30 days"),
                    React.createElement(Backups, { data: data }))); },
            },
            {
                menuItem: 'AuraDB Upload',
                render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
                    React.createElement("p", { className: "font-bold mb1" }, "Upload can take 5-10 minutes. Please note that your credentials will not be saved anywhere."),
                    React.createElement(AuraCloud, { data: data }))); },
            },
            {
                menuItem: 'Connect via HTTP',
                render: function () { return (React.createElement(Tab.Pane, { className: "expand-tab-pane pt4 pb4" },
                    React.createElement("pre", null,
                        React.createElement("code", null, "curl -u \"neo4j:".concat(data.password, "\" http://").concat(data.ip, ":").concat(data.port, "/db/neo4j/tx/commit \\\n\t\t\t\t\t\t\t\t-d '{\"statements\":[{\"statement\":\"return 1\"}]}' \\\n\t\t\t\t\t\t\t\t-H \"accept:application/json\" \\\n\t\t\t\t\t\t\t\t-H \"content-type:application/json\" \\\n\t\t\t\t\t\t\t\t-o /dev/null"))))); },
            }
        ];
        return _this;
    }
    SandboxItemExpand.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var usecase, codeSlug, _a, err, jsCodeResponse, _b, err1, pyCodeResponse, _c, err2, javaCodeResponse, _d, err4, graphqlCodeResponse, _e, err5, graphqlschemaCodeResponse, _f, err6, goCodeResponse, _g, err7, csharpCodeResponse, _h, js, php, java, py, graphql, graphqlschema, go, csharp, data, isCodeAvailable, isSandboxOwner, additonalPanels;
            var _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        usecase = this.props.data.usecase;
                        codeSlug = usecase;
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'javascript')))];
                    case 1:
                        _a = _k.sent(), err = _a[0], jsCodeResponse = _a[1];
                        if (!err) return [3 /*break*/, 3];
                        codeSlug = 'blank-sandbox';
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'javascript')))];
                    case 2:
                        _j = _k.sent(), err = _j[0], jsCodeResponse = _j[1];
                        _k.label = 3;
                    case 3: return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'python')))];
                    case 4:
                        _b = _k.sent(), err1 = _b[0], pyCodeResponse = _b[1];
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'java')))];
                    case 5:
                        _c = _k.sent(), err2 = _c[0], javaCodeResponse = _c[1];
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'graphql')))];
                    case 6:
                        _d = _k.sent(), err4 = _d[0], graphqlCodeResponse = _d[1];
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'graphqlschema')))];
                    case 7:
                        _e = _k.sent(), err5 = _e[0], graphqlschemaCodeResponse = _e[1];
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'go')))];
                    case 8:
                        _f = _k.sent(), err6 = _f[0], goCodeResponse = _f[1];
                        return [4 /*yield*/, to(Axios.get(getCodeSnippetUrl(codeSlug, 'csharp')))];
                    case 9:
                        _g = _k.sent(), err7 = _g[0], csharpCodeResponse = _g[1];
                        this.setState({
                            js: err ? null : jsCodeResponse.data,
                            py: err1 ? null : pyCodeResponse.data,
                            java: err2 ? null : javaCodeResponse.data,
                            graphql: err4 ? null : graphqlCodeResponse.data,
                            graphqlschema: err5 ? null : graphqlschemaCodeResponse.data,
                            go: err6 ? null : goCodeResponse.data,
                            csharp: err7 ? null : csharpCodeResponse.data
                        });
                        _h = this.state, js = _h.js, php = _h.php, java = _h.java, py = _h.py, graphql = _h.graphql, graphqlschema = _h.graphqlschema, go = _h.go, csharp = _h.csharp;
                        data = this.props.data;
                        isCodeAvailable = js || php || java || py || graphql || go || csharp;
                        isSandboxOwner = data.sbRel === 'IS_ALLOCATED';
                        additonalPanels = [];
                        // Add Actions Panel
                        if (isSandboxOwner)
                            additonalPanels.push(this.availablePanes[0]);
                        // Add Connections Panel
                        additonalPanels.push(this.availablePanes[1]);
                        // Add Code Panel
                        if (isCodeAvailable)
                            additonalPanels.push(getCodePanel(data, { js: js, php: php, java: java, py: py, graphql: graphql, graphqlschema: graphqlschema, go: go, csharp: csharp }));
                        // Add Backup and Aura Cloud Panel
                        if (isSandboxOwner) {
                            additonalPanels.push(this.availablePanes[2]);
                            additonalPanels.push(this.availablePanes[3]);
                            additonalPanels.push(this.availablePanes[4]);
                        }
                        this.setState({ finalPanes: additonalPanels });
                        return [2 /*return*/];
                }
            });
        });
    };
    SandboxItemExpand.prototype.handleCopyToClipboard = function (type) {
        var _a;
        var _this = this;
        this.setState((_a = {}, _a[type] = true, _a));
        setTimeout(function () {
            var _a;
            _this.setState((_a = {}, _a[type] = false, _a));
        }, 3000);
    };
    SandboxItemExpand.prototype.handleTabChange = function (event, data) {
        var activeIndex = data.activeIndex, panes = data.panes;
        var sandbox = this.props.data;
        window.neo4jSandbox.tracking.event('SANDBOX_EXPANDED_TAB_CLICK', {
            usecase: sandbox.usecase,
            title: panes[activeIndex].menuItem,
        });
    };
    SandboxItemExpand.prototype.render = function () {
        var finalPanes = this.state.finalPanes;
        return (React.createElement("div", { className: "mx4 my3" },
            React.createElement(ErrorBoundary, null,
                React.createElement(Tab, { menu: { secondary: true, pointing: true }, panes: finalPanes, onTabChange: this.handleTabChange }))));
    };
    return SandboxItemExpand;
}(Component));
export default SandboxItemExpand;
